<div class="">
    <mat-dialog-content class="account-box" style="overflow: hidden; scroll-behavior: unset;">
        <div class="text-center">
            <img src="assets/img/Frame2.png" alt="">
        </div>

        <div class="accont-created" style="margin-bottom:14px;">
            <h4 *ngIf="data?.html?.message; else textBlk1" [innerHTML]="data?.message" style="font-weight: 600; font-size: 20px; color: #1E2A36;"></h4>
            <ng-template #textBlk1>
                {{ data?.message }}
            </ng-template>
        </div>

        <div *ngIf="!isScoreScatExam" class="accont-created-desc" style="margin-bottom:14px;">
            <span *ngIf="data?.html?.message2; else textBlk2" [innerHTML]="data?.message2" ></span>
            <ng-template #textBlk2>
                {{ data?.message2 }}
            </ng-template>
        </div>

        <div *ngIf="isScoreScatExam" class="accont-created-desc" style="margin-bottom:14px;">
            <span>Your results will be announced soon.</span>
        </div>

        <div *ngIf="!isScoreScatExam" class="">
            <button class="assessment_pt-10 btn-block btn-link resend-otp" (click)="onNoClick()" type="button">CLOSE</button>
        </div>

        <div *ngIf="isScoreScatExam" class="">
            <button class="assessment_pt-10 btn-block btn-link resend-otp" (click)="backToScat()" type="button">DONE</button>
        </div>

        </mat-dialog-content>
        </div> 